import { observable, action } from 'mobx';
import { makeObservable } from 'mobx';


class DebugSettingsState {
    questionsTocFormat = 'prefixes';

    constructor() {
        makeObservable(this, {
            questionsTocFormat: observable,
            setQuestionsTocFormat: action,
        });
    }
    setQuestionsTocFormat(format) {
        if (!['prefixes', 'plain'].includes(format)) {
            throw new Error(`Invalid format: ${format}`);
        }
        this.questionsTocFormat = format;
        console.log(`Set questionsTocFormat to ${format}`);
    }
}

export const debugSettingsState = new DebugSettingsState();
